<template>
  <div
    class="UIContainer"
    :class="[{ 'UIContainer--with-padding': withPadding }, $attrs.class]"
  >
    <slot />

    <div v-if="$slots.left || $slots.right" class="UIContainer__grid">
      <div v-if="$slots.left" class="UIContainer__left">
        <slot name="left" />
      </div>
      <div v-if="$slots.right" class="UIContainer__right">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    withPadding?: boolean
  }>(),
  {
    withPadding: true,
  },
)
</script>

<style lang="scss" scoped>
.UIContainer {
  width: 100%;
  max-width: calc(1280px + 4rem);
  margin: 0 auto;
  padding: 0 1rem;

  &--with-padding {
    padding: 3rem 2rem 3rem;

    @include md {
      max-width: calc(1280px + 6rem);
      padding: 6rem 3rem 6rem;
    }
  }

  .UIContainer__grid {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;

    @include md {
      grid-template-columns: 1fr 1fr;
      justify-content: space-between;
    }
  }

  .UIContainer__left,
  .UIContainer__right {
    position: relative;
    min-width: 0;
  }
}
</style>
